export type Role = 'admin' | 'treasurer' | 'operator';

export interface User {
  id: string;
  email: string;
  name: string;
  avatar?: string;
  role: Role;
  companyId?: string;
}

export interface Invitation {
  id: string;
  email: string;
  role: Role;
  token: string;
  status: 'pending' | 'accepted';
  companyId: string;
  invitedBy: string;
  createdAt: string;
}

export const ROLE_LABELS: Record<Role, string> = {
  admin: 'Руководитель',
  treasurer: 'Казначей',
  operator: 'Оператор',
};

export const ROLE_DESCRIPTIONS: Record<Role, string> = {
  admin: 'Полный доступ: управление пользователями, расходами и настройками компании',
  treasurer: 'Управление расходами и финансовыми документами',
  operator: 'Только добавление и просмотр своих расходов',
};
